export const movies = [
  {
    id: "1",
    title: "欲望都市",
    type: "电视剧",
    region: "大陆",
    year: 2024,
    genres: ["剧情", "爱情"],
    tags: ["都市", "情感", "女性"],
    director: "陈默",
    cast: ["a1", "a4", "a9"],
    duration: "45分钟/集",
    episodes: 24,
    releaseDate: "2024-03-15",
    rating: 8.7,
    heat: 9860,
    featured: true,
    summary: "在一座永不熄灯的城市里，四个性格迥异的女性在事业、爱情与自我价值之间寻找平衡。苏离是一名理想主义的设计师，她用一场孤注一掷的创业换来掌声，也换来背叛；程见微在婚姻与自由之间反复拉扯，终于学会为自己而活。剧集以细腻的群像笔触，描摹当代都市女性在欲望与理智之间的每一次抉择，追问一个朴素却尖锐的问题：我们想要的，究竟是幸福，还是被人羡慕的生活？",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20drama%20series%20poster%20of%20four%20elegant%20asian%20women%20in%20a%20modern%20city%20skyline%2C%20deep%20wine%20red%20and%20gold%20tones%2C%20moody%20editorial%20key%20art%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sophisticated%20asian%20woman%20silhouette%20against%20a%20glowing%20night%20city%20skyline%2C%20deep%20wine%20red%20and%20gold%20lighting%2C%20moody%20atmospheric%2C%20dark%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-01&orientation=landscape",
  },
  {
    id: "2",
    title: "暗涌",
    type: "电影",
    region: "港台",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    tags: ["港片", "警匪", "反转"],
    director: "曾国安",
    cast: ["a6", "a11", "a14"],
    duration: "118分钟",
    episodes: 1,
    releaseDate: "2024-05-20",
    rating: 8.4,
    heat: 8720,
    featured: true,
    summary: "一桩尘封十年的旧案重新浮出水面，将退休警探与年轻检察官卷入同一张暗网。随着调查深入，他们发现真相并非非黑即白，每一个证词背后都藏着精心设计的谎言。影片以潮湿压抑的城市夜景为底色，在抽丝剥茧的叙事中，拷问正义的边界与人性的灰度。",
    poster: "https://readdy.ai/api/search-image?query=noir%20crime%20film%20poster%20of%20a%20lone%20asian%20detective%20in%20rain%20soaked%20alley%2C%20deep%20charcoal%20and%20blood%20red%20tones%2C%20gritty%20cinematic%20key%20art%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20rain%20slicked%20hong%20kong%20street%20at%20night%20with%20reflected%20neon%20and%20a%20solitary%20figure%2C%20moody%20charcoal%20and%20red%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-02&orientation=landscape",
  },
  {
    id: "3",
    title: "长夜将明",
    type: "网剧",
    region: "大陆",
    year: 2025,
    genres: ["剧情", "年代"],
    tags: ["抗战", "群像", "家国"],
    director: "林清和",
    cast: ["a2", "a5", "a13"],
    duration: "40分钟/集",
    episodes: 36,
    releaseDate: "2025-01-08",
    rating: 8.9,
    heat: 9240,
    featured: true,
    summary: "故事发生在风雨飘摇的年代，一群普通人在历史洪流中做出了不普通的选择。有人投笔从戎，有人隐忍坚守，有人以笔为刃。剧集以克制而磅礴的笔触，讲述普通人如何在最漫长的黑夜里，为黎明守住一盏灯。",
    poster: "https://readdy.ai/api/search-image?query=historical%20drama%20poster%20of%20asian%20figures%20in%20vintage%2040s%20coats%20against%20dawn%20light%2C%20muted%20sepia%20and%20dark%20teal%20tones%2C%20cinematic%20key%20art%2C%20simple%20textured%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20misty%20old%20chinese%20town%20at%20dawn%2C%20warm%20amber%20light%20breaking%20through%20cold%20fog%2C%20moody%20historical%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-banner-03&orientation=landscape",
  },
  {
    id: "4",
    title: "山海纪行",
    type: "纪录片",
    region: "大陆",
    year: 2024,
    genres: ["纪录片", "自然"],
    tags: ["自然", "人文", "摄影"],
    director: "秦川",
    cast: ["a13"],
    duration: "50分钟/集",
    episodes: 8,
    releaseDate: "2024-07-01",
    rating: 9.2,
    heat: 7630,
    featured: false,
    summary: "一支纪录片团队历时三年，跨越山海，记录下中国最壮阔的自然地貌与最质朴的人间烟火。从雪域高原到东海渔村，镜头以近乎虔诚的耐心，等待每一次日出、每一场迁徙、每一张笑脸。",
    poster: "https://readdy.ai/api/search-image?query=documentary%20poster%20of%20majestic%20mountains%20and%20sea%20with%20tiny%20lone%20traveler%2C%20muted%20sage%20green%20and%20stone%20tones%2C%20epic%20natural%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20aerial%20shot%20of%20misty%20mountains%20meeting%20the%20sea%20at%20sunrise%2C%20serene%20sage%20green%20and%20gold%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-04&orientation=landscape",
  },
  {
    id: "5",
    title: "声临其境",
    type: "综艺",
    region: "大陆",
    year: 2025,
    genres: ["综艺", "音乐"],
    tags: ["音乐", "竞技", "舞台"],
    director: "吴桐",
    cast: ["a7", "a12", "a15"],
    duration: "90分钟/期",
    episodes: 12,
    releaseDate: "2025-02-14",
    rating: 8.1,
    heat: 8150,
    featured: false,
    summary: "一档主打现场演唱实力比拼的音乐综艺，每一期都邀请不同年代的歌手同台竞演。没有修音，没有剧本，只有赤裸裸的嗓音与情绪。舞台灯光亮起的瞬间，实力才是唯一的通行证。",
    poster: "https://readdy.ai/api/search-image?query=vibrant%20music%20variety%20show%20poster%20with%20a%20singer%20silhouette%20under%20concert%20spotlights%2C%20wine%20red%20and%20gold%20stage%20glow%2C%20energetic%20key%20art%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20grand%20concert%20stage%20bathed%20in%20wine%20red%20and%20gold%20light%20with%20audience%2C%20high%20detail&width=1600&height=900&seq=movie-banner-05&orientation=landscape",
  },
  {
    id: "6",
    title: "星海远征",
    type: "动漫",
    region: "日韩",
    year: 2025,
    genres: ["动漫", "科幻"],
    tags: ["科幻", "冒险", "热血"],
    director: "高桥悠",
    cast: ["a10", "a16"],
    duration: "24分钟/集",
    episodes: 24,
    releaseDate: "2025-04-05",
    rating: 8.6,
    heat: 8890,
    featured: true,
    summary: "在人类文明濒临崩溃的遥远未来，一艘承载着最后希望的飞船驶向未知星系。少年领航员与他的伙伴们，在浩瀚星海中对抗孤独、对抗命运、也对抗彼此的分歧。这是一曲关于勇气与连接的星际史诗。",
    poster: "https://readdy.ai/api/search-image?query=anime%20sci%20fi%20poster%20of%20a%20young%20pilot%20before%20a%20vast%20nebula%20and%20spaceship%2C%20deep%20indigo%20and%20gold%20tones%2C%20dynamic%20key%20art%2C%20simple%20cosmic%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20anime%20scene%20of%20a%20starship%20sailing%20through%20a%20colorful%20nebula%2C%20deep%20blue%20and%20gold%20tones%2C%20epic%20sci%20fi%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-banner-06&orientation=landscape",
  },
  {
    id: "7",
    title: "迷雾围城",
    type: "电视剧",
    region: "大陆",
    year: 2024,
    genres: ["悬疑", "剧情"],
    tags: ["悬疑", "烧脑", "小镇"],
    director: "苏文",
    cast: ["a6", "a1", "a8"],
    duration: "45分钟/集",
    episodes: 20,
    releaseDate: "2024-09-12",
    rating: 8.3,
    heat: 8340,
    featured: false,
    summary: "一座常年被浓雾笼罩的小镇，接连发生离奇失踪案。新来的女记者与当地医生联手追查，却发现所有人都对二十年前的那场大火讳莫如深。雾越浓，真相越近，而真相往往比浓雾更令人窒息。",
    poster: "https://readdy.ai/api/search-image?query=mystery%20thriller%20tv%20poster%20of%20a%20foggy%20small%20town%20with%20a%20lone%20streetlight%2C%20cold%20grey%20and%20amber%20tones%2C%20eerie%20cinematic%20key%20art%2C%20simple%20misty%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dense%20fog%20covered%20mountain%20town%20at%20dusk%20with%20dim%20windows%2C%20cold%20grey%20and%20warm%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-07&orientation=landscape",
  },
  {
    id: "8",
    title: "孤舟",
    type: "电影",
    region: "欧美",
    year: 2023,
    genres: ["剧情", "文艺"],
    tags: ["文艺", "治愈", "获奖"],
    director: "Elias Moreau",
    cast: ["a2", "a9"],
    duration: "126分钟",
    episodes: 1,
    releaseDate: "2023-11-03",
    rating: 8.8,
    heat: 7210,
    featured: false,
    summary: "一位失去妻子的老船长，驾驶一艘旧船沿着海岸线缓缓航行。他在每一个停靠的港口遇见不同的人，听不同的故事，也一点点与自己的过去和解。影片节奏舒缓，像海面下暗流涌动的情绪，安静却有力量。",
    poster: "https://readdy.ai/api/search-image?query=arthouse%20film%20poster%20of%20an%20old%20lonely%20boat%20on%20a%20calm%20sea%20at%20sunset%2C%20muted%20blue%20grey%20and%20gold%20tones%2C%20minimal%20poetic%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20small%20boat%20on%20a%20vast%20calm%20ocean%20at%20golden%20sunset%2C%20serene%20blue%20grey%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-08&orientation=landscape",
  },
  {
    id: "9",
    title: "鎏金岁月",
    type: "电视剧",
    region: "港台",
    year: 2024,
    genres: ["剧情", "年代"],
    tags: ["年代", "家族", "商战"],
    director: "何家树",
    cast: ["a5", "a10", "a13"],
    duration: "45分钟/集",
    episodes: 30,
    releaseDate: "2024-06-18",
    rating: 8.5,
    heat: 7980,
    featured: false,
    summary: "从上世纪八十年代的黄金商埠讲起，一个家族企业在时代浪潮中几经沉浮。三代人的野心、情义与背叛交织成一幅浮世绘。金钱可以堆砌繁华，却买不回被岁月磨旧的初心。",
    poster: "https://readdy.ai/api/search-image?query=epic%20family%20saga%20poster%20of%20asian%20figures%20in%201980s%20attire%20before%20a%20grand%20mansion%2C%20warm%20gold%20and%20deep%20brown%20tones%2C%20cinematic%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20lush%201980s%20hong%20kong%20harbour%20skyline%20at%20dusk%2C%20warm%20gold%20and%20amber%20tones%2C%20nostalgic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-banner-09&orientation=landscape",
  },
  {
    id: "10",
    title: "无声告白",
    type: "电影",
    region: "大陆",
    year: 2025,
    genres: ["剧情", "家庭"],
    tags: ["家庭", "现实", "催泪"],
    director: "周宁",
    cast: ["a9", "a2", "a16"],
    duration: "112分钟",
    episodes: 1,
    releaseDate: "2025-03-21",
    rating: 8.6,
    heat: 8060,
    featured: false,
    summary: "一位沉默寡言的父亲，用一生笨拙地爱着他的女儿。直到父亲被确诊，女儿才在整理旧物时，读懂那些从未说出口的告白。影片以极简的对白与大量的生活细节，讲述中国式亲情里最深的隐忍与温柔。",
    poster: "https://readdy.ai/api/search-image?query=emotional%20family%20drama%20poster%20of%20a%20father%20and%20daughter%20back%20view%2C%20warm%20muted%20brown%20and%20cream%20tones%2C%20tender%20cinematic%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20father%20and%20daughter%20walking%20in%20a%20sunlit%20old%20neighborhood%20alley%2C%20warm%20amber%20and%20cream%20tones%2C%20nostalgic%20high%20detail&width=1600&height=900&seq=movie-banner-10&orientation=landscape",
  },
  {
    id: "11",
    title: "破晓之城",
    type: "网剧",
    region: "欧美",
    year: 2025,
    genres: ["科幻", "动作"],
    tags: ["科幻", "末世", "特效"],
    director: "Marcus Lane",
    cast: ["a4", "a11", "a14"],
    duration: "48分钟/集",
    episodes: 16,
    releaseDate: "2025-05-09",
    rating: 8.2,
    heat: 8510,
    featured: false,
    summary: "一场全球性的能源危机后，人类最后的城市被高墙分隔成上下两层。下层少年偶然获得一枚能改写系统的芯片，从此卷入一场关于秩序与自由的战争。当第一缕晨光穿透高墙，旧的规则开始崩塌。",
    poster: "https://readdy.ai/api/search-image?query=dystopian%20sci%20fi%20series%20poster%20of%20a%20walled%20city%20with%20a%20crack%20of%20dawn%20light%2C%20cold%20steel%20blue%20and%20wine%20red%20tones%2C%20cinematic%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20futuristic%20walled%20city%20at%20dawn%20with%20huge%20concrete%20walls%2C%20cold%20steel%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-11&orientation=landscape",
  },
  {
    id: "12",
    title: "荒野之上",
    type: "纪录片",
    region: "欧美",
    year: 2023,
    genres: ["纪录片", "自然"],
    tags: ["自然", "生态", "震撼"],
    director: "Sofia Brandt",
    cast: ["a8"],
    duration: "55分钟/集",
    episodes: 6,
    releaseDate: "2023-10-10",
    rating: 9.0,
    heat: 6890,
    featured: false,
    summary: "横跨五大洲的荒野纪录片，用超高速摄影捕捉雪豹的跃迁、候鸟的迁徙与极光下的狼群。镜头背后，是一群用生命记录生命的人。它让我们重新意识到，在人类之外，这颗星球还活着。",
    poster: "https://readdy.ai/api/search-image?query=wildlife%20documentary%20poster%20of%20a%20snow%20leopard%20on%20a%20rocky%20ridge%2C%20muted%20stone%20and%20sage%20tones%2C%20epic%20natural%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20wild%20snowy%20mountain%20valley%20with%20aurora%20and%20wolves%2C%20cool%20blue%20and%20sage%20tones%2C%20majestic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-banner-12&orientation=landscape",
  },
  {
    id: "13",
    title: "奇思妙想夜",
    type: "综艺",
    region: "港台",
    year: 2025,
    genres: ["综艺", "喜剧"],
    tags: ["搞笑", "脱口秀", "下饭"],
    director: "阿KEN",
    cast: ["a15", "a12", "a7"],
    duration: "60分钟/期",
    episodes: 16,
    releaseDate: "2025-06-01",
    rating: 7.9,
    heat: 7420,
    featured: false,
    summary: "一群喜剧人聚集在同一间深夜演播厅，用段子消解生活的荒诞。每期围绕一个真实又扎心的话题，从职场、婚恋聊到中年危机。笑到最后的，往往是那些戳中真相的瞬间。",
    poster: "https://readdy.ai/api/search-image?query=playful%20comedy%20talk%20show%20poster%20with%20colorful%20spotlights%20and%20microphone%2C%20wine%20red%20gold%20and%20cream%20tones%2C%20fun%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20warm%20late%20night%20comedy%20show%20stage%20with%20bokeh%20lights%2C%20wine%20red%20and%20gold%20tones%2C%20high%20detail&width=1600&height=900&seq=movie-banner-13&orientation=landscape",
  },
  {
    id: "14",
    title: "幻境物语",
    type: "动漫",
    region: "日韩",
    year: 2024,
    genres: ["动漫", "奇幻"],
    tags: ["奇幻", "治愈", "唯美"],
    director: "岩井绫",
    cast: ["a3", "a10"],
    duration: "23分钟/集",
    episodes: 12,
    releaseDate: "2024-04-12",
    rating: 8.5,
    heat: 7760,
    featured: false,
    summary: "一名能看见梦境色彩的女孩，误入由他人记忆构筑的幻境之城。为了找到回家的路，她必须一一解开城中沉睡者的心结。每一集都是一封写给孤独者的温柔情书，画风唯美，情绪绵长。",
    poster: "https://readdy.ai/api/search-image?query=whimsical%20fantasy%20anime%20poster%20of%20a%20girl%20in%20a%20magical%20dreamlike%20floating%20city%2C%20soft%20lavender%20and%20gold%20tones%2C%20ethereal%20key%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=900&seq=movie-poster-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20anime%20scene%20of%20a%20dreamlike%20floating%20city%20above%20clouds%20at%20dusk%2C%20soft%20pastel%20and%20gold%20tones%2C%20ethereal%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-banner-14&orientation=landscape",
  },
];